const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

const isSecureContext = () => {
  if (typeof window === 'undefined') {
    return false;
  }
  
  if (typeof window.isSecureContext !== 'undefined') {
    return window.isSecureContext;
  }
  
  const protocol = window.location.protocol;
  const isHttps = protocol === 'https:';
  const isLocal = isLocalhost;
  
  if (process.env.NODE_ENV === 'development') {
    console.log('[PWA] Security check:', {
      protocol,
      hostname: window.location.hostname,
      isSecureContext: window.isSecureContext,
      isHttps,
      isLocal,
      finalResult: isHttps || isLocal
    });
  }
  
  return isHttps || isLocal;
};

const registerValidSW = (swUrl, { onUpdate, onSuccess, onError } = {}) => {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      if (onSuccess) {
        onSuccess(registration);
      }
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (!installingWorker) {
          return;
        }
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller && onUpdate) {
              onUpdate(registration);
            }
          }
        };
      };
    })
    .catch((error) => {
      if (onError) {
        onError(error);
      } else if (process.env.NODE_ENV === 'development') {
        console.error('Service Worker registration failed:', error);
      }
    });
};

const checkValidServiceWorker = (swUrl, config) => {
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' }
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch((error) => {
      if (config && config.onError) {
        config.onError(error);
      } else if (process.env.NODE_ENV === 'development') {
        console.error('Service Worker validation failed:', error);
      }
    });
};

const registerServiceWorker = (config) => {
  if (!('serviceWorker' in navigator)) {
    if (process.env.NODE_ENV === 'development') {
      console.warn('Service Workers are not supported in this browser.');
    }
    return;
  }

  if (!isSecureContext()) {
    const protocol = window.location.protocol;
    const hostname = window.location.hostname;
    if (process.env.NODE_ENV === 'development') {
      console.warn(
        `Service Workers require HTTPS (or localhost). Current: ${protocol}//${hostname}. ` +
        `PWA installation will not work without HTTPS.`
      );
    }
    if (config && config.onError) {
      config.onError(new Error('Service Workers require secure context (HTTPS or localhost)'));
    }
    return;
  }

  const publicUrl = new URL(process.env.PUBLIC_URL || '/', window.location.href);
  if (publicUrl.origin !== window.location.origin) {
    if (process.env.NODE_ENV === 'development') {
      console.warn(
        `Service Worker registration skipped: PUBLIC_URL origin (${publicUrl.origin}) ` +
        `does not match current origin (${window.location.origin})`
      );
    }
    return;
  }

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js`;
    
    if (process.env.NODE_ENV === 'development') {
      console.log('[PWA] Attempting to register service worker:', {
        swUrl,
        currentUrl: window.location.href,
        protocol: window.location.protocol,
        isSecureContext: window.isSecureContext,
        isLocalhost
      });
    }
    
    if (isLocalhost) {
      checkValidServiceWorker(swUrl, config);
    } else {
      registerValidSW(swUrl, config);
    }
  });
};

const unregisterServiceWorker = () => {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch(() => {});
  }
};

export default registerServiceWorker;
export { unregisterServiceWorker };

